module.exports = {
      id: "stories-usage",
      viewBox: "0 0 33 27.835",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#stories",
      toString: function () {
        return this.url;
      }
    }